import axiosConfig from './axiosConfig';

export type EmailConfigFeatures = Record<string, boolean>;

export interface ProjectEmailConfig {
  email_config_id: number;
  email: string;
  features: EmailConfigFeatures;
  created_by?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface CreateProjectEmailConfigPayload {
  email: string;
  features: EmailConfigFeatures;
  created_by?: string;
}

export interface UpdateProjectEmailConfigPayload {
  email?: string;
  features?: EmailConfigFeatures;
}

function unwrapData<T>(responseData: any): T {
  if (Array.isArray(responseData)) return responseData as T;
  if (responseData?.data != null) return responseData.data as T;
  return responseData as T;
}

export async function listProjectEmailConfigs(): Promise<ProjectEmailConfig[]> {
  const response = await axiosConfig.get('project/projectEmailConfig');
  const data = unwrapData<ProjectEmailConfig[]>(response.data);
  return Array.isArray(data) ? data : [];
}

export async function createProjectEmailConfig(
  payload: CreateProjectEmailConfigPayload
): Promise<ProjectEmailConfig> {
  const response = await axiosConfig.post('project/projectEmailConfig', payload);
  return unwrapData<ProjectEmailConfig>(response.data);
}

export async function updateProjectEmailConfig(
  id: number,
  payload: UpdateProjectEmailConfigPayload
): Promise<ProjectEmailConfig> {
  const response = await axiosConfig.put(`project/projectEmailConfig/${id}`, payload);
  return unwrapData<ProjectEmailConfig>(response.data);
}

export async function deleteProjectEmailConfig(id: number): Promise<void> {
  await axiosConfig.delete(`project/projectEmailConfig/${id}`);
}
